import React from 'react';
import ProductionRule from './ProductionRule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCheck, faEdit} from '@fortawesome/free-solid-svg-icons';
import {pushWithBreaks} from "./display-grammar-util";

/**
 * Displays the grammar for the exercise. Might be editable or not.
 */
export class CfgGrammar extends React.Component {
    constructor(props) {
        super(props);
        let beforeProd = '';
        let prodList = [];
        let afterProd = '';
        if (props.grammar !== '') {
            const p = /([\s\S]*P\s*=\s*{)([^}]*)(}[\s\S]*)/m;
            const match = p.exec(props.grammar);
            if (match != null) {
                beforeProd = match[1];
                const prod = match[2];
                if (prod.length > 0) {
                    prodList = prod.split(/,\s*/);
                } else {
                    prodList = [];
                }
                afterProd = match[3];
            } else {
                beforeProd = "Something went wrong when parsing the production rules. Please check the syntax."
            }
        }
        this.state = {
            beforeProd: beforeProd,
            prodList: prodList,
            afterProd: afterProd
        }
    }

    static displayInteractableGrammar(beforeProd, prodList, afterProd, userSession) {
        let displayGrammar = [];
        let i = 1;
        pushWithBreaks(beforeProd, displayGrammar, 'before');
        prodList.forEach(function (element) {
            if (i > 1) {
                displayGrammar.push(<span key={i + ','}>,&nbsp;</span>)
            }
            if (element.includes('->')) {
                displayGrammar.push(<ProductionRule rule={element} key={i}
                                                    userSession={userSession}/>);
            } else {
                displayGrammar.push(<span key={i + '-element'}>{element}</span>)
            }
                i++;
            }
        );
        pushWithBreaks(afterProd, displayGrammar, 'after');
        return displayGrammar;
    }

    render() {
        const editable = this.props.editable;
        const beforeProd = this.state.beforeProd;
        const prodList = this.state.prodList;
        const afterProd = this.state.afterProd;
        const userSession = this.props.userSession;
        return (
            <div className='panel' id='grammarPanel'>
                <button id='grammarEditIcon'
                    onClick={this.props.handleChangeGrammar}>
                    {editable
                        ? <FontAwesomeIcon className={'clickable-icon'} icon={faCheck}/>
                        : <FontAwesomeIcon className={'clickable-icon'} icon={faEdit}/>
                    }
                    {editable
                        ? <span className={'accessibility-label'}> edit grammar done</span>
                        : <span className={'accessibility-label'}>edit grammar</span>}

                </button>
                <div className='grammar'>
                    {editable
                        ? <span><label htmlFor="tGrammar"
                                       className={'accessibility-label'}>Grammar</label>
                            <textarea id='tGrammar' rows='4'
                                      defaultValue={this.props.grammar}/></span>
                        : CfgGrammar.displayInteractableGrammar(beforeProd,
                            prodList, afterProd, userSession)
                    }
                </div>
                {prodList.length === 0 ?
                    <div className='no-task-message'>There is no task! Click New
                        in the menu to generate a task or click the edit symbols
                        for a custom task.</div> : ''}
            </div>
        );
    }
}
